import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IEmailConfirmationRepository} from '../repositories/email-confirmation.repository.interface';

@Injectable()
export class EmailConfirmationService {

  constructor(@Inject('IEmailConfirmationRepository') private emailConfirmationRepository: IEmailConfirmationRepository) { }

  public confirm(email: string, token: string): Observable<string> {
    return this.emailConfirmationRepository.confirm(email, token);
  }

}
